'use client';
/***
 *
 * @file components/InputDropdown/index.tsx
 * @description InputDropdown component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Truminds Software System
 * @since 13 Feb 2024
 *
 */

import React, { useEffect, useState } from "react";
// import "./InputDropdown.scss";
import DropdownMenu from "../DropdownMenu";
import { getData } from "@/actions/page.action";
import { T_KeyValue, T_Value } from "@/types/app.type";
import classNames from "classnames";
import ImageWrapper from "../ImageWrapper";

type Props = {
  /** id of Input Field content type */
  id?: string | undefined;
  /** css class of Input Field content type */
  className?: string;
  /** label color */
  labelColor?: string;
  /** label size */
  labelSize?: string;
  /** content of Input Field content type */
  data?: any;
  /** content type of Input Field content */
  typeid?: string;
  inputsRef?: React.MutableRefObject<Record<string, any | null | undefined>>; //HTMLInputElement | null;
  label?: string;
  type: string;
  name: string;
  customName?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  pattern?: string;
  entryTags?: string;
  options?: T_Value | T_Value[]; //string | T_KeyValue[];
  helperText?: string | undefined;
  confirmationErrorMessage?: string;
  requiredErrorMessage?: string;
}

const InputDropdown = ({
  id = "select",
  name = "select",
  customName = "select",
  className = '',
  data = {},
  typeid = '',
  inputsRef,
  placeholder = "Please select an option",
  label = "Dropdpwn",
  labelColor = "",
  labelSize = "",
  pattern = "",
  required = false,
  disabled = false,
  entryTags,
  options = "[]",
  helperText = "",
  confirmationErrorMessage = "",
  requiredErrorMessage = "",
}: Props) => {
  const elData = data;

  // const [inputValue, setInputValue] = useState<string>('');
  const [emailPurpose, setEmailPurpose] = useState<any | string>(null);
  const [purposeList, setPurposeList]: any[] = useState([]);
  const [dList, setDList] = useState<T_KeyValue>({ items: [] });
  // const [dList, setDList] = useState<{[key: string]: T_Value | T_Value[]}>({items: []});
  const [inputErrorMessage, setInputErrorMessage] = useState<string | null>(elData?.content?.errorMessage || elData?.content?.requiredErrorMessage || requiredErrorMessage);
  const [isValidInput, setIsValidInput] = useState<boolean>(true);
  const [confirmationError, setConfirmationError] = useState<T_KeyValue>({});
  // [{"internalName":"sorting-value-1","value":"1","label":"One"},{"internalName":"sorting-value-2","value":"2","label":"Two"}]

  // digitalBaseplateFutures
  const handleInvalid = (e: React.InvalidEvent<HTMLInputElement>) => {
    e.preventDefault();
    const input = e.currentTarget;
    // if (input.value === "") {
    //   input.setCustomValidity(placeholder);
    // } else {
    //   input.setCustomValidity('');
    // }

    if(required && !input?.value) {
      setInputErrorMessage(elData?.content?.errorMessage || elData?.content?.requiredErrorMessage || requiredErrorMessage);
      setIsValidInput(false);
    } else {
      setIsValidInput(true);
    }    
  }
  // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const input = e.currentTarget;
  //   debugger;
  //   if(required && !input?.value) {
  //     setInputErrorMessage(elData?.content?.errorMessage || elData?.content?.requiredErrorMessage || requiredErrorMessage);
  //     setIsValidInput(false);
  //   } else {
  //     setIsValidInput(true);
  //   }
  // }

  useEffect(() => {
    if (entryTags) { (async () => { setDList(await getData({ tags: entryTags }) as any) })(); }
    else {
      setDList((() => {
        return { options: (typeof (options) === "string" ? JSON.parse(options) : options) || [] };
      })())
    }
    // if(storage === "Success"){
    //   // setFormStatus("Success");
    // }
  }, [entryTags, options]);

  useEffect(() => {
    let arr: T_KeyValue[] = (() => {
      return (dList?.items || (dList?.options && !Array.isArray(dList?.options) ? [dList?.options] : dList?.options) || [])?.map((item: any) => {
        return {
          value: item?.id || item?.value || "",
          internalName: item?.content?.internalName || item?.internalName || item?.label || "",
          name: item?.content?.caption || item?.label || ""
        }
      })
    })();

    arr.sort((a: T_KeyValue, b: T_KeyValue) => a.internalName.localeCompare(b.internalName));
    setTimeout(() => {
      setPurposeList([...[placeholder ? { value: '', name: placeholder } : {}], ...arr]);
    }, 100)
  }, [dList]);

  return (
    <>
      <div
        className="form-group"
        data-testid="InputField"
      >
        <DropdownMenu
          id={id}
          className="InputDropdown-container"
          data-testid="InputDropdown"
          name={name === "custom" ? customName : name}
          label={label}
          lableClassName="aaaa" //"form-control-label !flex !items-center !flex-row py-1 !px-0 !gap-0.5"
          labelColor={labelColor}
          labelSize={labelSize}
          labelStyle={{ color: labelColor, paddingLeft: "0px" }}
          setSelectedValue={(e: string) => {
            console.log("------ eeeee -----", e);
            const selectedPurpose: T_KeyValue = purposeList?.find((p: any) => p.value === e);
            setEmailPurpose(selectedPurpose);

            if(required && !selectedPurpose?.value) {
              setInputErrorMessage(elData?.content?.errorMessage || elData?.content?.requiredErrorMessage || requiredErrorMessage);
              setIsValidInput(false);
            } else {
              setIsValidInput(true);
            }
          }}
          isValidInput={isValidInput}
          options={
            [
              // ...[placeholder ? {value: '', name: placeholder} : {}],
              // {value: 'co-creating a new business', name: 'co-creating a new business'}, 
              // { value: 'renting out space for my business', name: 'renting out space for my business'}, 
              // { value: 'something else', name: 'something else'}
              ...purposeList
            ]} required={required}>
          <>
            <input 
              id={`${id || name === "custom" ? customName : name}`}
              name={name === "custom" ? customName : name} 
              title={`${name === "custom" ? customName : name}`}
              className={classNames(
                "hide-input",
                {
                  'bp-form-error':
                    !isValidInput
                }
              )} 
              // aria-invalid={!isValidInput}
              data-error={!isValidInput}
              type="text" 
              // onInvalid={handleInvalid}
              // onInput={(e: React.FormEvent<HTMLInputElement>) => {
              //   e.currentTarget.setCustomValidity('');
              // }}
              value={emailPurpose?.name ?? ""}
              readOnly />
            <input id={`${id}_id`} name={`${name === "custom" ? customName : name}_id`} title={`${name === "custom" ? customName : name}_id`} className="hide-input" type="text" 
              onInvalid={handleInvalid}
              // onInput={(e: React.FormEvent<HTMLInputElement>) => {
              //   e.currentTarget.setCustomValidity('');
              // }}
              // value={inputValue}
              // onChange={handleChange}
              // onFocus={handleFocus}
              // onBlur={handleBlur}
              value={emailPurpose?.value ?? ""}
              readOnly
              required={required} />
          </>
        </DropdownMenu>
        {helperText && <p className="flex leading-[133%]"><ImageWrapper src="/information.svg" alt="alt" width={20} height={20} loader={({ src }) => src} /><span className='ml-[.3rem] text-text-default'>{helperText}</span></p>}
        {/* <p className="m-0 text-input-error-message">
          {elData?.content?.errorMessage}
        </p> */}
        {/* {inputError} */}
        {/* Err: {JSON.stringify(isValidInput)} */}
        {(!isValidInput) &&
          <p className="m-0 text-input-error-message">
            {/* Err: <pre>{JSON.stringify(confirmationError, null, 2)}</pre> */}
            {inputErrorMessage}
            {/* {elData?.content?.formatErrorMessage || formatErrorMessage} */}
          </p>
        }
        {confirmationError?.[name]?.error &&
          <p className="m-0 text-input-error-message">
            {/* Err: <pre>{JSON.stringify(confirmationError, null, 2)}</pre> */}
            {/* {formatErrorMessage} */}
            {confirmationError?.[name]?.message}
          </p>
        }
        {/* {inputRef?.current?.form?.name}
        <pre>{JSON.stringify(ctxFormData[inputRef?.current?.form?.name], null, 2)}</pre> */}
      </div>
    </>
  );
};

export default InputDropdown;
